import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/types';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.apiKeys || initialState;

export const selectApiKeys = createSelector(
  [selectDomain],
  apiKeysState => apiKeysState,
);
